import ApiService from "../api";

export default class CentroCustoService extends ApiService {

    constructor() {
        super("/api/centro-custo");
    }

    listar() {
        return this.get("");
    }

    buscarPorCodigo(codigo) {
        return this.get(`/${codigo}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(codigo, dto) {
        return this.put(`/${codigo}`, dto);
    }

    excluir(codigo) {
        return this.delete(`/${codigo}`);
    }

    sincronizar() {
        return this.put(`/sincronizar-fortes`);
    }
}
